
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import $ from 'jquery'
import linkIcon from './assets/images/link-icon.png'

// eslint-disable-next-line
!(function (t) {
  function e () {
    var e = this || self
    e.globalThis = e
    delete t.prototype._T_
  }
  // eslint-disable-next-line
  'object' != typeof globalThis && (this ? e() : (t.defineProperty(t.prototype, '_T_', {configurable: !0, get: e}), _T_))
})(Object)

export default {
  data () {
    return {

    }
  },
  methods: {
    // 配置系统信息
    setSystemInfo: function () {
      // 设置顶级样式
      document.body.className = 'custom-blue'
      // 设置浏览器标签上的图标
      const link = document.createElement('link')
      link.setAttribute('rel', 'shortcut icon')
      link.setAttribute('type', 'image/x-icon')
      link.setAttribute('href', linkIcon)
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    // 设置rem  1920下基础字体是100px，其它分辨率下，在100的基础上动态设置基础字体
    setRem: function () {
      // const windowWidth = $(window).width()
      // const baseFont = windowWidth / 1920 * 100
      // document.documentElement.style.fontSize = `${baseFont}px`
      // sessionStorage.setItem('windowWidth', windowWidth)
      // 获取系统的缩放比例
      let devicePixelRatio = 1
      const screen = window.screen
      const ua = navigator.userAgent.toLowerCase()
      if (window.devicePixelRatio !== undefined) {
        devicePixelRatio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          devicePixelRatio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        devicePixelRatio = window.outerWidth / window.innerWidth
      }
      // 设置rem根字体大
      const windowWidth = $(window).width()
      const baseFont = windowWidth / 1920 * 100
      document.documentElement.style.fontSize = `${baseFont}px`
      // 设置页面宽度，用户动态计算内容部分的宽度
      document.documentElement.style.setProperty('--windowWidth', `${windowWidth}px`)
      // 设置当前的缩放比例，用于在缩放大于100%时，调大字体，以免字体看起来很小
      document.documentElement.style.setProperty('--devicePixelRatio', devicePixelRatio)
      sessionStorage.setItem('windowWidth', windowWidth)
      sessionStorage.setItem('devicePixelRatio', devicePixelRatio)
    },
    // 监听窗口变化
    addResizeListener: function () {
      window.addEventListener('resize', this.handleResize)
    },
    // 取消监听窗口变化
    cancelResizeListener: function () {
      window.removeEventListener(this.handleResize)
    },
    // 处理窗口变化
    handleResize: function () {
      const windowWidth = $(window).width()
      // 如果宽度与变化前的宽度不一致，重绘页面
      if (parseInt(windowWidth) !== parseInt(sessionStorage.getItem('windowWidth'))) {
        this.setRem()
        this.$router.go(0)
        sessionStorage.setItem('windowWidth', windowWidth)
      }
    }
  },
  created () {
    this.setSystemInfo()
    this.setRem()
    this.addResizeListener()
  },
  beforeDestroy () {
    this.cancelResizeListener()
  }
}
</script>

<style lang="scss">
  #app{
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue